import React, { useState, useCallback } from 'react';
import Card from 'components/card';
import styles from 'components/card-item/index.module.scss';
import classNames from 'classnames/bind';
import iconAlert from 'assets/icon_alert_red.svg';

const cx = classNames.bind(styles);

const CardItem = ({ style,content, bgColor = '', fontColor = '', label = '', onClick, rightContent, warning = false }) => {
  const [rightContentWidth, setRightContentWidth] = useState(0);
  const cardItemStyle = cx({
    'card-item': true,
    [fontColor]: true,
    [bgColor]: true,
  });

  const rightRef = useCallback(node => {
    if (node) {
      setRightContentWidth(node.clientWidth);
    }
  }, []);

  return (
    <Card>
      <div className={cardItemStyle} onClick={onClick} style={style}>
        <div className={styles['content']} style={{ width: `calc(100% - ${rightContentWidth}px)` }}>
          {content}
          {warning ? <img className={styles.warning} src={iconAlert} alt="warning" /> : <></>}
          {label === '' ? '' : <span className={styles['label']}>{label}</span>}
        </div>
        <div className={styles['card-right-content']} ref={rightRef}>
          {rightContent}
        </div>
      </div>
    </Card>
  );
};

export default CardItem;
